import cuid from "cuid";
import { toDiscountCodePayload } from "../form";
import View from "./View";

const Create = ({ addDiscountCode, setOpenCreate, openCreate }) => {
  const onClose = () => setOpenCreate(false);

  const onSubmit = (data) => {
    return addDiscountCode({
      variables: {
        data: {
          id: cuid(),
          ...toDiscountCodePayload(data),
        },
      },
    });
  };

  return <View onSubmit={onSubmit} onClose={onClose} open={openCreate} />;
};

export default Create;
